import styled from "styled-components";
import Badge from "@material-ui/core/Badge";

export const Pointer = styled.div`
  & {
    color: rgb(153, 153, 153);
  }
  &:hover {
    cursor: pointer;
  }
`;

export const GridBadge = styled(Badge)`
  & {
    margin-left: 8px;
    margin-right:24px;
  }
`;

export const TableButtonBar = styled.div`
  display:flex;
  flex-flow:row;
`;
export const Spacer = styled.div`
  flex-grow:1;
`;
